import { useEffect, useState } from "react";
import "./CurrentTimeLine.css";

/**
 * Blinking primary-color line marking the current time. Rendered inside a
 * day column (position: relative) of the day/week views; positions itself
 * from the grid's first hour and slot height. Renders nothing outside the
 * visible hour range. Self-updates every minute.
 */
function CurrentTimeLine({ firstHour, lastHour, slotHeight }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  const minutes = now.getHours() * 60 + now.getMinutes();
  const startMinutes = firstHour * 60;
  const endMinutes = lastHour * 60;
  if (minutes < startMinutes || minutes > endMinutes) return null;

  const top = ((minutes - startMinutes) / 60) * slotHeight;

  return (
    <div className="current-time-line" style={{ top: `${top}px` }}>
      <span className="current-time-dot" />
    </div>
  );
}

export default CurrentTimeLine;
